export default "__VITE_ASSET__C$kOMKgL__"